import endpoints from '@/utils/constants';
import { apiHelper, authHelper } from '@/utils/helpers';

const actions ={
    saveSupplier(context){
        return new Promise((resolve,reject)=>{
            apiHelper.call('post',`${endpoints.BASE_URL}${endpoints.API.suppliers}`,context.state.supplier).then((res)=>{
               
                if(res.status === 201){
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err)
            })
        })
    },

    getSupplierList(context){
        return new Promise((resolve,reject)=>{
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.suppliers}`).then((res)=>{
                if(res.status === 200) {
                    context.commit('setSupplierList', res.data);
                }
            }).catch(err =>{
                reject(err);
            })
        })
    },

    fetchSupplier(context,supplierId){
        return new Promise((resolve,reject)=>{
            apiHelper.call('get',`${endpoints.BASE_URL}${endpoints.API.suppliers}/${supplierId}`).then((res)=>{
                if(res.status === 200){
                        resolve(res.data);
                }
            }).catch(err =>{
                reject(err);
            })                          
        })
    },

    updateSupplier(context){
          return new Promise((resolve,reject)=>{
              apiHelper.call('put', `${endpoints.BASE_URL}${endpoints.API.suppliers}/${context.state.supplier.supplierId}`,context.state.supplier).then((res)=> {
                  if(res.status === 200)
                  {
                   context.commit('setSupplier', res.data);
                   resolve(res);
                  }
              }).catch(err =>{
                  reject(err);
              })
          });
      },
  


}
export default actions;